import React from 'react';
import {motion} from 'framer-motion';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/chat-01.module.css';

import {ReactComponent as InputImg} from '../../assets/chat01/input.svg';
import {ReactComponent as InputMobileImg} from '../../assets/chat01/input-mobile.svg';
import {ReactComponent as SaasImg} from '../../assets/chat01/saas.svg';
import {ReactComponent as SaasMobileImg} from '../../assets/chat01/saas-mobile.svg';
import {ReactComponent as DarvisLogoActiveImg} from '../../assets/logo/darvis-logo-active.svg';

const springMotion = {
    type: 'spring',
    mass: 1,
    stiffness: 80,
    damping: 15,
    duration: 0.5
};

const wheelMotion = {
    ease: 'easeIn',
    type: 'spring',
    stiffness: 80,
    damping: 20,
    duration: 0.8
};

export default function Chat01() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    return (
        <div className={styles.wrapper}>
            <div className={styles.boxTitle}>
                <p>채팅 기능</p>
                <div>
                    <motion.div
                        initial={{ opacity: 0, x: -200 }}
                        animate={{ opacity: 1, x: 0, clipPath: 'inset(0 0 0 0)' }}
                        transition={springMotion}
                    >
                        <p>데이터 여기저기 찾지 말고</p>
                        <p className={styles.textWithLogo}>
                            {mobileSmall ? <span>DARVIS</span> : <span><DarvisLogoActiveImg /></span>}
                            &nbsp;에게 물어보세요!
                        </p>
                    </motion.div>
                </div>
                <div>
                    <motion.div
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ 
                            opacity: [0, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 0.95, 1],
                            scale: [0, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 0.95, 1],
                        }}
                        transition={{
                            opacity: { 
                                duration: 1.2,
                                times: [0.75, 0.75, 0.8, 0.84, 0.88, 0.91, 0.94, 0.96, 0.98, 1],
                                ease: 'easeIn'
                            },
                            scale: { 
                                duration: 1.2,
                                times: [0.75, 0.75, 0.8, 0.84, 0.88, 0.91, 0.94, 0.96, 0.98, 1],
                                ease: 'easeIn'
                            }
                        }}
                    >
                        {mobileSmall ? <InputMobileImg/> : <InputImg />}
                    </motion.div>
                </div>
            </div>
            <motion.div
                className={styles.boxSaasImg}
                style={{ transformOrigin: 'center calc(100% + 25px)' }}
                initial={{ rotate: mobileSmall ? -30 : -60, y: 50 }}
                animate={{ rotate: 0, y: 0 }}
                transition={wheelMotion}
            >
                {mobileSmall ? <SaasMobileImg /> : <SaasImg />}
            </motion.div>
        </div>
    );
}
